import BaseRepository from "@/services/resources/repository";
import byPublication from "@/services/resources/mixins/query-by-publication";
import byCountry from "@/services/resources/mixins/query-by-country";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byPublication).$mix(byCountry);
    }
}

export default Repository;
